export const FirstTimeItems = [
  {
    title: 'Real-time Presentation',
    description:
      'Like “present” mode on a slide deck; when you click “Next” everyone in meeting mode moves along with you.',
    icon: '👀',
  },
  {
    title: 'Notes & Next Steps',
    description: 'Reminds you to take notes & capture nexts steps for each topic.',
    icon: '📓',
  },
  {
    title: 'Wrap Up Items',
    description: 'Spend the final moments of the meeting confirming and prioritizing who accountable for follow ups.',
    icon: '✅',
  },
  {
    title: 'Email Summary',
    description: 'All workspace members will receive an email with a meeting summary after the meeting.',
    icon: '📩',
  },
];

export const WelcomeBackItems = [
  {
    title: 'New Visual Agenda',
    description: 'Quickly understand what topic is coming up next.',
    icon: '👀',
  },
  {
    title: 'Snooze/Revisit',
    description: 'Set a topic schedule or snooze it to a later date.',
    icon: '⏰',
  },
  {
    title: 'Past Notes',
    description: 'Clear view of notes from prior meetings without needing to click.',
    icon: '📓',
  },
];
